/**
 * Created by Administrator on 2017/10/30.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import { DragulaService } from 'ng2-dragula/ng2-dragula';
declare var alertify:any;
@Component({
  templateUrl:'./message.html'
})

export class Message implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private dragulaService: DragulaService
  ){

  }

  private data:any={
    content:[]
  };
  private imagePath:string='';
  private page={pageNumber:1,pageSize:10}


  private postData:any=[
  ];
  ngOnInit(): void {
    this.getPath();
  }

  //推送
  public isLoading :boolean = false;
  private push(id:any):void{
    this.isLoading= true;
    this.http.postData(API.messagePushAll+"?"+'id'+'='+id,this.postData).then(res=>{
      let data=res;
      this.isLoading= false;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }
  //成员推送
  private memberPush(id:any):void{
    this.isLoading= true;
    this.http.postData(API.messagePush+"?"+'id'+'='+id,this.postData).then(res=>{
      let data=res;
      this.isLoading= false;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }


  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
    this.http.getData(API.message,{
      pageNumber: this.page.pageNumber-1,
      pageSize:this.page.pageSize,
    }).then(res=>{
      this.data = res.data;
      for (let i=0;i<this.data.content.length;i++){
        this.data.content[i].imageEn = this.imagePath+this.data.content[i].imageEn;
        this.data.content[i].imageTc = this.imagePath+this.data.content[i].imageTc;
      }
    });
  }

  private editCategory(id:number):void{
    this.router.navigate(['index/message',id])
  }

  private deleteCategory(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.messageDelete+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }



}




// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/message/message.component.ts